import { updateListMethod } from '../../utils/list'
import {
  LC_UPDATE_LIST,
  LC_UPDATE_LIST_METHOD,
  LC_UPDATE_FORM,
  LC_UPDATE_FORM_FIELD,
  LC_UPDATE_PREVIEW
} from '../actions/learning-continuum.actions'

const initialState = {
  list: [],
  totalList: 0,
  form: {},
  preview: null
}

const learningContinuumReducer = (state = initialState, action) => {
  const newState = { ...state }
  const { type, payload } = action

  switch (type) {
    case LC_UPDATE_LIST:
      if (payload.curriculumId) {
        newState[payload.curriculumId] = { list: payload.data, totalList: payload.count }
      } else {
        newState.list = payload.data
        newState.totalList = payload.count
      }
    break
    case LC_UPDATE_LIST_METHOD:
      if (payload.curriculumId) {
        if (newState[payload.curriculumId]) {
          newState[payload.curriculumId].list = updateListMethod(payload.method, payload.data, newState[payload.curriculumId].list)
          if (payload.method === 'DELETE') {
            newState[payload.curriculumId].totalList--
          }
          if (payload.method === 'POST') {
            newState[payload.curriculumId].totalList++
          }
        } else {
          newState[payload.curriculumId] = { list: updateListMethod(payload.method, payload.data, []), totalList: 1 }
        }
      } else {
        newState.list = updateListMethod(payload.method, payload.data, newState.list)
        if (payload.method === 'DELETE') {
          newState.totalList--
        }
        if (payload.method === 'POST') {
          newState.totalList++
        }
      }
    break
    case LC_UPDATE_FORM:
      newState.form = payload
    break
    case LC_UPDATE_FORM_FIELD:
      newState.form = { ...newState.form, [payload.field]: payload.value }
    break
    case LC_UPDATE_PREVIEW:
      newState.preview = payload
    break
    default:
      break
  }

  return newState
}

export default learningContinuumReducer